import { useState } from 'react';
import { merge } from 'lodash';

const initState = () => ({
    personalizedContentMap: {
        original: null,
        translated: null,
    },
    showTranslatedContent: false,
    isInitialized: false,
});

const useTranslationToggle = () => {
    const [translationState, setTranslationState] = useState(initState());
    const { personalizedContentMap, showTranslatedContent } = translationState;

    const onTranslationToggle = (translatedPersonalizedContent) => {
        if (showTranslatedContent) {
            setTranslationState({
                ...translationState,
                showTranslatedContent: false,
            });
        } else {
            const newTranslationState = {
                ...translationState,
                showTranslatedContent: true,
            };

            if (translatedPersonalizedContent) {
                newTranslationState.personalizedContentMap = merge({}, personalizedContentMap, {
                    translated: translatedPersonalizedContent,
                });
            }

            setTranslationState(newTranslationState);
        }
    };

    const setOriginalContent = (personalizedContent) => {
        setTranslationState({
            ...translationState,
            personalizedContentMap: merge({}, personalizedContentMap, {
                original: personalizedContent,
            }),
            isInitialized: true,
        });
    };

    return { onTranslationToggle, setOriginalContent, translationState };
};

export default useTranslationToggle;
